import { connect } from "react-redux";
import setEditing from "../../store/epics/setEditing";
import sendConfirmation from "../../store/epics/sendConfirmation";
import updateUserData from "../../store/epics/updateUserData";
import {
  TRACK_EDIT_DAYS,
  TRACK_ADD_HOUR,
  TRACK_DELETE_HOUR,
  TRACK_EDIT_HOUR,
  callOnlyOnce
} from "../../store/mixpanel";
import {
  updateDts,
  setHours,
  setDays,
  removeHours,
  createDays,
  removeDays
} from "../../store/epics/updateDailyText";

export default connect(
  ({ time, user, dailytexts, editing }) => ({
    time,
    user,
    dailytexts,
    editing
  }),
  dispatch => {
    const trackDays = callOnlyOnce(() => {
      dispatch({
        type: TRACK_EDIT_DAYS
      });
    });

    return {
      setEditing(editing) {
        return dispatch(setEditing(editing));
      },
      updateUser({ user_id, user }) {
        return dispatch(updateUserData({ user_id, user }));
      },
      updateDts({ hours, days }) {
        return dispatch(updateDts({ hours, days })).then(() =>
          dispatch(sendConfirmation())
        );
      },
      setHours(hours, isEdited) {
        dispatch({
          type: isEdited ? TRACK_EDIT_HOUR : TRACK_ADD_HOUR,
          payload: { hours }
        });

        return dispatch(setHours({ hours })).then(() =>
          dispatch(sendConfirmation())
        );
      },
      removeHours(hours) {
        dispatch({
          type: TRACK_DELETE_HOUR,
          payload: { hours }
        });

        return dispatch(removeHours({ hours })).then(() =>
          dispatch(sendConfirmation())
        );
      },
      setDays(days) {
        trackDays();
        return dispatch(setDays({ days })).then(() =>
          dispatch(sendConfirmation())
        );
      },
      createDays(days) {
        trackDays();
        return dispatch(createDays({ days })).then(() =>
          dispatch(sendConfirmation())
        );
      },
      removeDays(days) {
        trackDays();
        return dispatch(removeDays({ days })).then(() =>
          dispatch(sendConfirmation())
        );
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/routes/Home/connected.js